<template>
  <BaseAction>
    <SecondaryButton @click.native="openDialog" textColor="#a63232">
      <v-icon>
        {{ getApplicationActionIcon("withdraw") }}
      </v-icon>
      Withdraw Candidate
    </SecondaryButton>
    <WithdrawCandidatesDialog
      :isOpen="isOpen"
      @close="closeDialog"
      :applicationsIds="applicationsIds"
    />
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import WithdrawCandidatesDialog from "@/views/bookings/components/ConfirmDialogs/WithdrawCandidatesDialog";
import BaseAction from "@/components/common/BaseAction";
import { getApplicationActionIcon } from "@/utils/bookings";

export default {
  name: "WithdrawCandidatesAction",
  components: {
    BaseAction,
    WithdrawCandidatesDialog,
    SecondaryButton
  },
  props: {
    applicationsIds: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog({ success }) {
      this.isOpen = false;
      if (success) {
        this.$emit("statusChanged");
      }
    },
    getApplicationActionIcon
  }
};
</script>
